import { ISubscriptionsState } from '@/@types'

const state: ISubscriptionsState = {
  paymentMethod: 'card',
  paymentEntries: {
    country: '',
    firstName: '',
    lastName: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    company: '',
    last4DigitsOfCreditCard: '',
    creditCardVendor: '',
  },
  isIn3dsFlow: false,
  isInPartnerFlow: false,
  promotionalField: '',
  paymentMethodOnFile: '',
  usersCurrentSubscriptions: [],
  userHasSubscription: false,
  usersCurrentSubscriptionsWithPasses: [],
}

export default state
